export default __webpack_public_path__ + "static/media/Q6_0.fad99c56.png";